import {useGetPatient, useRecordPatientView} from '@/modules/patients/api'
import {PatientAboutTab} from '@/modules/patients/components/patient-details/about/patient-about-tab'
import {GFRLab} from '@/modules/patients/components/patient-details/gft-lab/gft-lab'
import {PatientHistoryTab} from '@/modules/patients/components/patient-details/history/patient-history-tab'
import {PatientInfoHeader} from '@/modules/patients/components/patient-details/patient-info-header'
import {PatientDetailsTabsList} from '@/modules/patients/components/patient-details/tabs-list'
import {TherapyTab} from '@/modules/patients/components/patient-details/therapy/therapy-tab'
import {Box, Tabs} from '@chakra-ui/react'
import {useState} from 'react'

export interface PatientDetailsPageProps {
  patientId: string
  // the opened tab is uncontrolled — initialTab is only read on mount, and
  // tab changes flow through onTabChange (the route mirrors them into search params)
  initialTab?: string
  onTabChange?: (tab: string) => void
}

export function PatientDetailsPage({patientId, initialTab = 'about', onTabChange}: PatientDetailsPageProps) {
  const [patient] = useGetPatient(patientId)
  useRecordPatientView(patientId)
  const [tab, setTab] = useState(initialTab)

  return (
    <Box
      width="100%"
      maxWidth="calc(100vw - 5rem)"
      marginX="auto"
      pb="4"
      height="100%"
      display="flex"
      flexDirection="column"
      minHeight="0"
    >
      {patient && (
        <Tabs.Root
          value={tab}
          onValueChange={({value}) => {
            setTab(value)
            onTabChange?.(value)
          }}
          lazyMount
          display="flex"
          flexDirection="column"
          flex="1"
          minHeight="0"
        >
          <Box position="sticky" top="0" zIndex="sticky" bg="bg" flexShrink="0">
            <PatientInfoHeader patient={patient} />
            <PatientDetailsTabsList />
          </Box>

          <TherapyTab patient={patient} />
          <PatientAboutTab patient={patient} />
          <GFRLab patient={patient} />
          <PatientHistoryTab patient={patient} />
        </Tabs.Root>
      )}
    </Box>
  )
}
